import React from "react"
import {Button, ButtonGroup} from "reactstrap";
import BaseComponent from "../BaseComponent";
import * as PropTypes from "prop-types";
import {INSPECTION_STATUS_COLOR} from "../../utils/Global";
import label from "enqc-utilities/src/label/Label";

class StatusWidget extends BaseComponent{

    render() {
        let status = this.props.status??{}
        let statusColors = this.props.statusColors??INSPECTION_STATUS_COLOR
        let icon = this.props.icon??undefined
        let disabled = this.props.disabled??true
        let onClick = this.props.onClick??(()=>{})
        return (
            <ButtonGroup>
                <Button
                    disabled={disabled}
                    style={{borderColor:statusColors[status.name]}}
                    onClick={onClick}
                    className={"btn-light btn-outline-light align-items-center "+(icon&&" border-right-0")}>
                    <strong style={{color:statusColors[status.name]}}>{label(status.name)}</strong>
                </Button>
                {icon&&(
                    <Button
                        disabled={disabled}
                        style={{borderColor:statusColors[status.name], borderLeft:'0', background:statusColors[status.name]}}
                        onClick={onClick}
                        className="text-white align-items-center">
                        <span>{icon}</span>
                    </Button>
                )}
            </ButtonGroup>
        );
    }
}
StatusWidget.propTypes = {
    status:PropTypes.object.isRequired,
    statusColors:PropTypes.array,
    icon:PropTypes.object,
    disabled:PropTypes.bool,
    onClick:PropTypes.func,
}

export default StatusWidget;